 // Function to show the popup
        function showPopupRXX(productId,productTitle) {
            document.getElementById('popuprxx').style.display = 'flex';

          gtag('event', 'drop-hint', {
              product_id: productId,
              product_title: productTitle
          });
        }

        // Function to close the popup
        function closePopupRXX() {
            document.getElementById('popuprxx').style.display = 'none';
        }

        // Function to close the popup if clicked outside the content
        function overlayClickRXX(event) {
            // Check if the click was on the overlay (outside the content)
            if (event.target.id === 'popuprxx') {
                closePopupRXX();
            }
        }